import EntryTermContainer from "./EntryTerm";
export { EntryTermContainer };
